'use es6';

import Client from 'AdsUI/data/Client';
export default {
  removeAdwordsCampaign(opts) {
    const {
      id,
      accountId
    } = opts;
    return Client.apiRequest(`ads/v1/entity/manage/adwords/${accountId}/campaign/${id}`, {
      type: 'DELETE',
      query: {
        accountId
      }
    });
  }

};